import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'

export type Notif = {
  id: string
  order_id: string | null
  pesan: string
  is_read: boolean
  created_at: string
}

export function useNotifications(userId: string | undefined) {
  const [notifs, setNotifs] = useState<Notif[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userId) {
      setLoading(false)
      return
    }

    // Initial fetch
    supabase
      .from('notifications')
      .select('id, order_id, pesan, is_read, created_at')
      .eq('pelanggan_id', userId)
      .order('created_at', { ascending: false })
      .limit(20)
      .then(({ data }) => {
        setNotifs(data ?? [])
        setLoading(false)
      })

    // Realtime subscription
    const channel = supabase
      .channel(`notifs:${userId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `pelanggan_id=eq.${userId}`,
        },
        payload => {
          setNotifs(prev => [payload.new as Notif, ...prev])
        }
      )
      .subscribe()

    return () => { supabase.removeChannel(channel) }
  }, [userId])

  async function markAllRead() {
    if (!userId) return
    await supabase
      .from('notifications')
      .update({ is_read: true })
      .eq('pelanggan_id', userId)
      .eq('is_read', false)
    setNotifs(prev => prev.map(n => ({ ...n, is_read: true })))
  }

  const unreadCount = notifs.filter(n => !n.is_read).length

  return { notifs, unreadCount, loading, markAllRead }
}
